// extracted by mini-css-extract-plugin
module.exports = {"parent":"tooltip_parent__93o_d","tooltip":"tooltip_tooltip__2fGuE"};